module.exports = new __parcel__URL__("cycloneshot.7cf71a54.png").toString();